import { render, staticRenderFns } from "./RptDevActTot_BK_ZQ.vue?vue&type=template&id=6b54a4f8"
import script from "./RptDevActTot_BK_ZQ.vue?vue&type=script&lang=js"
export * from "./RptDevActTot_BK_ZQ.vue?vue&type=script&lang=js"
import style0 from "./RptDevActTot_BK_ZQ.vue?vue&type=style&index=0&id=6b54a4f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports